import { render, staticRenderFns } from "./2_product_center_details_3.vue?vue&type=template&id=dcd3aa40&scoped=true&"
import script from "./2_product_center_details_3.vue?vue&type=script&lang=js&"
export * from "./2_product_center_details_3.vue?vue&type=script&lang=js&"
import style0 from "./2_product_center_details_3.vue?vue&type=style&index=0&id=dcd3aa40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd3aa40",
  null
  
)

export default component.exports